import { useCallback } from 'react';
import { useLinkedEntry } from '../../../components/nucleus/Inspector';
import { readPlugin, readAutomation, readRun } from './items';

// AN ?open= LINK TO A PLUGIN, AN AUTOMATION OR A RUN the page's list does not
// hold (a run older than the page, a plugin the store hides): read on its own
// once the list is in, kept, and said plainly when it is not there.
//   const plugins = usePluginList(groupId);
//   const { entry, notice } = useLinkedPlugin(groupId, openId, plugins);
// `list` is a hooks.js read ({ data, … }) whose data has `find(id)`, or for
// runs one whose data has `runs`.

export function useLinkedPlugin(groupId, openId, list) {
    const read = useCallback((id) => readPlugin(groupId, id), [groupId]);
    return useLinkedEntry(openId, { ready: !!list?.data, find: (id) => list?.data?.find(id), read, kind: 'plugin' });
}

export function useLinkedAutomation(groupId, openId, list) {
    const read = useCallback((id) => readAutomation(groupId, id), [groupId]);
    // a flow's id is the list's too: it is not read as an automation
    const find = (id) => list?.data?.find(id) || list?.data?.findFlow?.(id);
    return useLinkedEntry(openId, { ready: !!list?.data, find, read, kind: 'automation' });
}

export function useLinkedRun(groupId, openId, feed) {
    const read = useCallback((id) => readRun(groupId, id), [groupId]);
    const find = (id) => (feed?.data?.runs || []).find((r) => String(r.id) === String(id)) || null;
    return useLinkedEntry(openId, { ready: !!feed?.data, find, read, kind: 'run' });
}
